
<template>
    <InboxMultiDropDown :dataTrees="diaryArray" placement="top-start">
        <slot />
    </InboxMultiDropDown>
</template>

<script setup>
import InboxMultiDropDown from '@/components/multidropdown/InboxMultiDropdown.vue';
const props = defineProps({
    diaryArray: {
        type: Array,
        default: [],
    },
});
</script>

<style scoped></style>
